import type { HTMLAttributes, Ref } from "react";

import { clsx } from "../utils/clsx";

interface TransitionRouterContainerProps extends HTMLAttributes<HTMLElement> {
  ref?: Ref<HTMLElement>;
}

export const transitionRouterContainerClassName = "transition-router-container";

export const TransitionRouterContainer = ({ ref, className, ...props }: TransitionRouterContainerProps) => (
  <main
    {...props}
    className={clsx(
      className,
      transitionRouterContainerClassName,
      "data-[stage=entering]:animate-[fade-in_0.15s_forwards] data-[stage=leaving]:animate-[fade-out_0.15s_forwards] motion-reduce:animate-none",
    )}
    ref={ref}
  />
);
